import { circularProgressClasses } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useSpinnerStyles = makeStyles()(theme => ({
  root: {
    position: 'relative',
  },

  centered: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },

  firstCircle: {
    display: 'block',
    color: theme.palette.grey[300],
  },

  secondCircle: {
    color: theme.palette.primary.main,
    animationDuration: '550ms',
    position: 'absolute',
    top: 0,
    left: 0,

    [`& .${circularProgressClasses.circle}`]: {
      strokeLinecap: 'round',
    },
  },
}));
